import { createBrowserHistory } from 'history'


const history = createBrowserHistory()

export const getHistory = () => history